const DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL

// Same tenant-domain convention as docs/loyalty-api-integration.md §3: current
// hostname, falling back to NEXT_PUBLIC_DOMAIN_URL on localhost/SSR (no `window`).
// Shared by every loyalty hook that talks to a `/public/**` endpoint keyed by domain
// (use-loyalty-notice.ts, use-loyalty-properties.ts).
export function resolveLoyaltyDomain(): string | null {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : null
  return hostname && hostname !== 'localhost' && hostname !== 'uat-booking.lotussolution.cloud'
    ? hostname
    : DOMAIN_URL || null
}
